import DOMPurify from 'dompurify'

interface ProductDescriptionProps {
  description: string
}

export const ProductDescription = ({
  description
}: ProductDescriptionProps) => {
  return (
    <p
      className="line-clamp-3 font-normal !leading-normal text-neutral-600 md:line-clamp-4 [&_*]:[&_*]:text-sm"
      dangerouslySetInnerHTML={{
        __html: DOMPurify.sanitize(description)
      }}
    />
  )
}
